import React, { useState } from "react";

export const Accordion = ({ content, text, ...props }) => {
  const [expanded, setExpanded] = useState(
    props.initialState !== false ?? props.alwaysOpen
  );

  function expand() {
    if (props.alwaysOpen || !props.initialState) {
      return;
    }
    setExpanded(!expanded);
  }

  function callExpand(e) {
    if (e.key === "Enter") {
      expand();
    }
  }

  return (
    <div
      className="mdn-Accordion"
      aria-label="Accordion Control Group"
      key={props.index}
      onClick={expand}
      onKeyPress={callExpand}
    >
      <div
        className={`mdn-Accordion-box ${expanded ? "is-expanded" : ""}`}
        aria-label="Acordion clicável para expandir o conteúdo"
        style={{
          cursor:
            props.status === "DISPONIVEL" && !props.eligible ? "default" : "",
        }}
      >
        <a
          className="mdn-Accordion-toggle mdn-Text mdn-Text--body"
          role="button"
          aria-controls="content-1"
          {...props}
        >
          {text}
          {props.status === "DISPONIVEL" && !props.eligible ? null : (
            <i
              className="mdn-Accordion-icon mdn-Icon-baixo mdn-Icon--lg"
              onClick={expand}
              onKeyPress={callExpand}
            ></i>
          )}
        </a>
        <div className="mdn-Accordion-content">
          <p className="mdn-Text mdn-Text--body">{content}</p>
          <i></i>
        </div>
      </div>
    </div>
  );
};

export default Accordion;
